/* eslint-disable react/prop-types */
import { ClipLoader } from "react-spinners";

const Loader = ({ message = "Downloading Content" }) => {
  return (
    <div className="flex flex-col items-center justify-center h-screen mt-4 space-y-2 bg-background text-foreground">
      <ClipLoader color="#22C55E" size={20} className="mt-2" />
      <p className="text-sm text-brand-light font-medium">{message}</p>
    </div>
  );
};

export default Loader;
